import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const base = "/";

export default new Router(
{
    mode: "history",
    base,
    routes:
    [
        {
            path: "/password",
            name: "password",
            component: require("@/pages/Password.vue").default
        },
        {
            path: "/keywords",
            name: "keywords",
            component: require("@/pages/Keywords.vue").default
        },
        {
            path: "/pzns",
            name: "pzns",
            component: require("@/pages/Pzns.vue").default
        },
        {
            path: "/users",
            name: "users",
            component: require("@/pages/Users.vue").default
        },
        {
            path: "/pharmacies",
            name: "pharmacies",
            component: require("@/pages/Pharmacies.vue").default
        },
        {
            path: "/customers",
            name: "customers",
            component: require("@/pages/Customers.vue").default
        },        
        {
            path: "/notfound",
            name: "notfound",
            component: require("@/pages/Notfound.vue").default
        },
        {
            path: "/scraper",
            name: "scraper",
            component: require("@/pages/Scraper.vue").default
        },
        {
            path: "/files",
            name: "files",
            component: require("@/pages/Files.vue").default
        },
        {
            path: "/pzndetails",
            name: "pzndetails",
            component: require("@/pages/Pzndetails.vue").default
        },
        {
            path: "/advertising",
            name: "advertising",
            component: require("@/pages/Advertising.vue").default
        },                
        {
            path: "/categoryads",
            name: "categoryads",
            component: require("@/pages/Categoryads.vue").default
        },                
        {
            path: "/websearch",
            name: "websearch",
            component: require("@/pages/Websearch.vue").default
        },                
        {
            path: "/amazonsearch",
            name: "amazonsearch",
            component: require("@/pages/Amazonsearch.vue").default
        },                
        {
            path: "/amazoncategories",
            name: "amazoncategories",
            component: require("@/pages/Amazoncategories.vue").default
        },                        
        {
            path: "/zalandokeywords",
            name: "zalandokeywords",
            component: require("@/pages/Zalandokeywords.vue").default
        },                
        {
            path: "/zalandocategories",
            name: "zalandocategories",
            component: require("@/pages/Zalandocategories.vue").default
        },                
        {
            path: "/dashboards",
            name: "dashboards",
            component: require("@/pages/Dashboards.vue").default
        },                
        {
            path: "/settings",
            name: "settings",
            component: require("@/pages/Settings.vue").default
        },                
        {
            path: "/sessions",
            name: "sessions",
            component: require("@/pages/Sessions.vue").default
        },                
        {
            path: "/pzncheck",
            name: "pzncheck",
            component: require("@/pages/Pzncheck.vue").default
        },            
        {
            path: "/currentpzns",
            name: "currentpzns",
            component: require("@/pages/Currentpzns.vue").default
        },            
        {
            path: "/deeplink",
            name: "deeplink",
            component: require("@/pages/Deeplink.vue").default
        },            
        {
            path: "*",
            redirect: "/notfound"
        }
    ],
});